import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import { GuidedHouseholdReviewIntroLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

const layout = withGuidedHouseholdReviewLayout(GuidedHouseholdReviewIntroLayout);

export const GuidedHouseholdReviewIntroPageTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection, refreshPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      layout={layout}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink, refresh: refreshPageContentCollection }}
      resource={resource}
    />
  );
};

GuidedHouseholdReviewIntroPageTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
